<template>
  <div class="error-page">
    <div class="error-img"></div>
    <div class="error-box">
      <h4>404</h4>
      <div class="msg">抱歉您访问的页面不存在</div>
      <div>
        <el-button type="primary" @click="goHome">返回首页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import './error.scss'
  export default {
    methods: {
      goHome() {
        this.$router.push('/')
      }
    }
  }
</script>

<style lang="scss">

</style>